import { render, staticRenderFns } from "./DetalheBeneficiario.vue?vue&type=template&id=0216b96e"
import script from "./DetalheBeneficiario.vue?vue&type=script&lang=js"
export * from "./DetalheBeneficiario.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports